import { Component, Input, OnInit } from '@angular/core';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';

@Component({
    selector: 'navigation-item-wiki-button',
    templateUrl: './navigation-item-wiki-button.component.html',
    styleUrls: ['./navigation-item-wiki-button.component.scss'],
    standalone: false
})
export class NavigationItemWikiButtonComponent implements OnInit {
  @Input() navigationItem: NavigationItemData;

  constructor() {}

  isWikiOpen = false;

  ngOnInit(): void {}
}
